<template>
  <div class="container-fluid" id="wrapper">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container-fluid">
        <a class="navbar-brand" href="#" style="padding-left: 10px"
          ><h3>{{ $t("VDI2770Creator") }}</h3></a
        >
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item" v-if="getCookieStatus == 'decline'" >
                <a class="nav-link" href="#" @click.prevent="removeCookie">Change Cookie Status</a>
            </li>
            <li class="nav-item" v-if="getCurrentRoute()">
              <router-link
                to="/vdi2770viewer/files"
                class="nav-link"
                :data-toggle="!getAcceptToS ? 'modal' : ''"
                data-target="#ToSModal"
                @click="checkToS()"
                >{{ $t("VDI2770Viewer") }}</router-link
              >
            </li>

            <li class="nav-item">
              <router-link to="/" class="nav-link">{{ $t("Home") }}</router-link
              >|
            </li>
            <li class="nav-item">
              <LocaleSwitcher />
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="container-fluid">
      <div class="row pb-5 pt-3">
        <router-view></router-view>
      </div>
    </div>

    <footer class="footer  mt-5  py-2 bg-light text-center fixed-bottom">
      <div class="row">
        <div class="col"><h5 class="text-muted">Impressum</h5></div>
        <div class="col">
          <h5 class="text-muted">{{ $t("FooterPrivacyShort") }}</h5>
        </div>
        <div class="col">
          <h5 class="text-muted">{{ $t("ToSshort") }}</h5>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <router-link to="/impressum" class="nav-link">{{$t("impressum")}}</router-link>
        </div>
        <div class="col">
          <router-link to="/privacy" class="nav-link">{{
            $t("FooterPrivacy")
          }}</router-link>
        </div>
        <div class="col">
          <router-link to="/terms-of-use" class="nav-link"
            >{{ $t("ToS") }}
          </router-link>
        </div>
      </div>
    </footer>

    <vue-cookie-accept-decline
      :debug="false"
      :disableDecline="false"
      :showPostponeButton="false"
      @clicked-accept="cookieClickedAccept"
      @clicked-decline="cookieClickedDecline"
      @removed-cookie="cookieRemovedCookie"
      @status="cookieStatus"
      elementId="myPanel1"
      position="bottom-left"
      ref="myPanel1"
      transitionName="slideFromBottom"
      type="floating"
    >
      <!-- Optional -->
      <!-- <template #postponeContent>&times;</template>    @clicked-postpone="cookieClickedPostpone"-->

      <template #message>
        {{$t("cookie")}}
        <a href="/privacy" target="_blank">{{$t("learnMore")}}</a>
      </template>

      <template #declineContent>{{$t("OptOut")}}</template>

      <template #acceptContent>{{$t("accept")}}</template>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
import LocaleSwitcher from "./components/utils/LocaleSwitcher.vue";
import ModalUtils from "./components/utils/ModalsUtils.vue";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import i18n from "@/i18n";
export default {
  name: "App",
  data() {
    return {};
  },
  components: { LocaleSwitcher, ModalUtils },

  methods: {
    ...mapActions(["setIsPackageUnit", "setCookieStatus"]),
    getCurrentRoute(){
      if (this.$route.name == "Privacy" || this.$route.name == "ToS" || this.$route.name == "impressum"){
        return false
      }
      return true
    },
    checkToS(){
      this.setIsPackageUnit(true)
      $("#ToSModal").on("show.bs.modal", function (event) {
        var title = "ToSshort";
        // var body = "ToSChapter2";
        var modal = $(this);
        modal.find(".modal-title").text(i18n.global.t(title));
        // modal.find(".modal-body").text(i18n.global.t(body));
        modal
          .find(".modal-target")
          .text(event.relatedTarget.attributes[0].nodeValue);
      });
    },
    cookieStatus(status) {
      this.$store.dispatch("setCookieStatus", status);
    },
    cookieClickedAccept() {
      this.$store.dispatch("setCookieStatus", "accept");
    },
    cookieClickedDecline() {
      this.$store.dispatch("setCookieStatus", "decline");
    },
    cookieClickedPostpone() {
      this.$store.dispatch("setCookieStatus", "postpone");
    },
    cookieRemovedCookie() {
      this.$store.dispatch("setCookieStatus", null);
      this.$refs.myPanel1.init();
    },
    removeCookie() {
      this.$refs.myPanel1.removeCookie();
    },
  },
  computed: {
    ...mapGetters(["getCookieStatus", "getAcceptToS"]),
  },
};
</script>

<style>
@import "../node_modules/bootstrap-icons";

.nav-item {
  padding-right: 10px;
  padding-block-start: 1rem;
}

.container-fluid {
  padding-left: 20px;
  padding-right: 20px;
}

.hGen {
  text-decoration: underline #adb5bd 2px;
}
</style>
<style>
/* @import "../node_modules/vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css"; */
.cookie__bar {
  -ms-overflow-style: none;
  position: fixed;
  overflow: hidden;
  box-sizing: border-box;
  z-index: 9999;
  width: 100%;
  background: #eee;
  padding: 20px 20px;
  align-items: center;
  box-shadow: 0 -4px 4px rgba(198, 198, 198, 0.05);
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  font-size: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu,
    Cantarell, “Fira Sans”, “Droid Sans”, “Helvetica Neue”, Arial, sans-serif;
  line-height: 1.5;
}
.cookie__bar--bottom {
  bottom: 0;
  left: 0;
  right: 0;
}
.cookie__bar--top {
  top: 0;
  left: 0;
  right: 0;
}
.cookie__bar__wrap {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
@media (min-width: 768px) {
  .cookie__bar__wrap {
    flex-direction: row;
  }
}
.cookie__bar__postpone-button {
  margin-right: auto;
  -ms-flex: 1 1 auto;
}
@media (min-width: 768px) {
  .cookie__bar__postpone-button {
    margin-right: 10px;
  }
}
.cookie__bar__postpone-button:hover {
  opacity: 0.8;
  cursor: pointer;
}
.cookie__bar__content {
  margin-right: 0;
  margin-bottom: 20px;
  font-size: 0.9rem;
  max-height: 103px;
  overflow: auto;
  width: 100%;
  -ms-flex: 1 1 auto;
}
@media (min-width: 768px) {
  .cookie__bar__content {
    margin-right: auto;
    margin-bottom: 0;
  }
}
.cookie__bar__buttons {
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  width: 100%;
}
@media (min-width: 768px) {
  .cookie__bar__buttons {
    flex-direction: row;
    width: auto;
  }
}
.cookie__bar__buttons__button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  border-radius: 3px;
  font-size: 0.9rem;
}
.cookie__bar__buttons__button:hover {
  cursor: pointer;
  text-decoration: none;
}
.cookie__bar__buttons__button--accept {
  -ms-flex: 1 1 auto;
  background: #4caf50;
  background: linear-gradient(#5cb860, #4caf50);
  color: #fff;
}
.cookie__bar__buttons__button--accept:hover {
  background: #409343;
}
.cookie__bar__buttons__button--decline {
  -ms-flex: 1 1 auto;
  background: #f44336;
  background: linear-gradient(#f55a4e, #f44336);
  color: #fff;
  margin-bottom: 10px;
}
.cookie__bar__buttons__button--decline:hover {
  background: #f21f0f;
}
@media (min-width: 768px) {
  .cookie__bar__buttons__button--decline {
    margin-bottom: 0;
    margin-right: 10px;
  }
}
.cookie__floating {
  -ms-overflow-style: none;
  position: fixed;
  overflow: hidden;
  box-sizing: border-box;
  z-index: 9999;
  width: 90%;
  background: #fafafa;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  box-shadow: 0 4px 8px rgba(198, 198, 198, 0.3);
  border: 1px solid #ddd;
  font-size: 1rem;
  font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu,
    Cantarell, “Fira Sans”, “Droid Sans”, “Helvetica Neue”, Arial, sans-serif;
  line-height: 1.5;
  border-radius: 6px;
  bottom: 10px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
@media (min-width: 768px) {
  .cookie__floating {
    max-width: 300px;
  }
}
@media (min-width: 768px) {
  .cookie__floating--bottom-left {
    bottom: 20px;
    left: 20px;
    right: auto;
    margin: 0 0;
  }
}
@media (min-width: 768px) {
  .cookie__floating--bottom-right {
    bottom: 20px;
    right: 20px;
    left: auto;
    margin: 0 0;
  }
}
@media (min-width: 768px) {
  .cookie__floating--top-right {
    top: 20px;
    bottom: auto;
    right: 20px;
    left: auto;
    margin: 0 0;
  }
}
@media (min-width: 768px) {
  .cookie__floating--top-left {
    top: 20px;
    bottom: auto;
    right: auto;
    left: 20px;
    margin: 0 0;
  }
}
.cookie__floating__postpone-button {
  display: inline-flex;
  padding: 5px 0 0 20px;
  margin-bottom: -10px;
  margin-right: auto;
}
.cookie__floating__postpone-button:hover {
  opacity: 0.8;
  cursor: pointer;
}
.cookie__floating__content {
  font-size: 0.95rem;
  margin-bottom: 5px;
  padding: 15px 20px;
  max-height: 105px;
  overflow: auto;
}
@media (min-width: 768px) {
  .cookie__floating__content {
    margin-bottom: 10px;
  }
}
.cookie__floating__buttons {
  transition: all 0.2s ease;
  display: flex;
  flex-direction: row;
  height: auto;
  width: 100%;
}
.cookie__floating__buttons__button {
  background-color: #eee;
  font-weight: bold;
  font-size: 0.9rem;
  width: 100%;
  min-height: 40px;
  white-space: nowrap;
  user-select: none;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  border-left: none;
  border-right: none;
  padding: 0.375rem 0.75rem;
}
.cookie__floating__buttons__button:first-child {
  border-right: 1px solid #ddd;
}
.cookie__floating__buttons__button:hover {
  cursor: pointer;
  text-decoration: none;
}
.cookie__floating__buttons__button--accept {
  color: #4caf50;
  -ms-flex: 1 1 auto;
}
.cookie__floating__buttons__button--accept:hover {
  background: #409343;
  color: #fff;
}
.cookie__floating__buttons__button--decline {
  color: #f44336;
  -ms-flex: 1 1 auto;
}
.cookie__floating__buttons__button--decline:hover {
  background: #f21f0f;
  color: #fff;
}
/* .slideFromBottom-enter,
.slideFromBottom-leave-to {
  transform: translate(0px, 10em);
}

.slideFromBottom-enter-to,
.slideFromBottom-leave {
  transform: translate(0px, 0px);
}

.slideFromBottom-enter-active {
  transition: transform 0.2s ease-out;
}

.slideFromBottom-leave-active {
  transition: transform 0.2s ease-in;
}

.slideFromTop-enter,
.slideFromTop-leave-to {
  transform: translate(0px, -10em);
}

.slideFromTop-enter-to,
.slideFromTop-leave {
  transform: translate(0px, 0px);
}

.slideFromTop-enter-active {
  transition: transform 0.2s ease-out;
}

.slideFromTop-leave-active {
  transition: transform 0.2s ease-in;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
} */
</style>
